var map = {
	"./IVL_LangerLogo.svg": "a3cf",
	"./SWB_Logo.svg": "028f",
	"./dark-logo.svg": "5fcd",
	"./default-logo.svg": "6b40",
	"./evo-logo.svg": "7e4e",
	"./gasag-solution-blau.svg": "dd5c",
	"./gasag-solution-weiss.svg": "3521",
	"./gegenbauer-dark-logo.svg": "24fa",
	"./gegenbauer-light-logo.svg": "4f52",
	"./light-logo.svg": "cf2b",
	"./nexerion_blau.svg": "afb6",
	"./nexerion_weiss.svg": "3d0c",
	"./wiro-logo.svg": "bf2c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22d1";